import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisbursmentComponent } from './disbursment.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';
import { DisbursDtlsCompModule } from "./disburs-dtls-comp/disburs-dtls-comp.module";
import { TruncateTooltipDirective } from 'src/app/shared/helpers/truncate-tooltip.directive';
import { DisbursmentRoutingModule } from './disbursment-routing.module';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatAutocompleteModule } from '@angular/material/autocomplete';



@NgModule({
  declarations: [
    DisbursmentComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    DisbursDtlsCompModule,
    TruncateTooltipDirective,
    DisbursmentRoutingModule,
    MatSortModule,
    MatPaginatorModule,
    MatAutocompleteModule
]
})
export class DisbursmentModule { }
